import { render } from "./StepCircle.vue?vue&type=template&id=5ae80c9f"
import script from "./StepCircle.vue?vue&type=script&lang=js"
export * from "./StepCircle.vue?vue&type=script&lang=js"
script.render = render

export default script